import { NumberedInput as UINumberedInput, type NumberedInputProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

type Props = Omit<NumberedInputProps, 'placeholder'> & { placeholder?: string };

const NumberedInput = forwardRef<HTMLInputElement, Props>((
  { placeholder, ...props },
  ref
) => {
  const { t } = useTranslation();
  return (
    <UINumberedInput
      {...props}
      placeholder={placeholder ?? t('components.numberedInput.placeholder')}
      ref={ref}
    />
  );
});

export default NumberedInput;
